import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Currency } from 'dinero.js'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { getConceptByName, useConcepts } from 'modules/payroll_bundle/hooks/useConcepts'
import { ResultValidation } from 'modules/payroll_bundle/hooks/useResultValidations'
import { DEFAULT_RESULT_CONCEPT, NOT_PAID } from 'modules/payroll_bundle/lib/constants'
import {
  ResultRowData,
  ResultsTableData,
  getResultRowsDataByEmployee,
  getResultRowsDataPaymentStatus,
} from 'modules/payroll_bundle/lib/resultsTableData'
import type { Payments } from 'modules/payroll_bundle/store/collections/payments'

import Header from './Header'
import PaymentsTab from './PaymentsTab'
import ResultsTab from './ResultsTab'
import { Tabs } from './types'

interface Props {
  selectedResultsRowData: ResultRowData | null
  resultsTableData: ResultsTableData
  currency: Currency
  payments: Payments
  policyPeriodIds: { current: number; previous: number }
  onSidePanelClose: () => void
  validations: ResultValidation[]
}

const EmployeeSidePanel = ({
  selectedResultsRowData,
  resultsTableData,
  currency,
  payments,
  policyPeriodIds,
  onSidePanelClose,
  validations,
}: Props) => {
  const [currentTab, setCurrentTab] = useState(Tabs.Results)
  const employeeResultRowsData =
    selectedResultsRowData !== null
      ? getResultRowsDataByEmployee(resultsTableData, selectedResultsRowData.employee.id)
      : []
  const { concepts } = useConcepts()
  const netSalaryConcept = getConceptByName(concepts, DEFAULT_RESULT_CONCEPT.net_pay)

  return (
    <Sidepanel
      overlay={false}
      boxPadding={false}
      width="wide"
      onClose={onSidePanelClose}
      open={selectedResultsRowData !== null}
      headerBorder
      closeLabel={i18n.t('common.close')}
    >
      {selectedResultsRowData !== null && (
        <Box>
          <Header
            employeePaymentsStatus={
              netSalaryConcept === null
                ? NOT_PAID
                : getResultRowsDataPaymentStatus(
                    employeeResultRowsData,
                    payments,
                    policyPeriodIds.current,
                    netSalaryConcept.id
                  )
            }
            currentTab={currentTab}
            onChangeTab={setCurrentTab}
            selectedResultsRowData={selectedResultsRowData}
          />

          {currentTab === Tabs.Results && (
            <ResultsTab
              employeeResultRowsData={employeeResultRowsData}
              payments={payments}
              policyPeriodIds={policyPeriodIds}
              currency={currency}
              validations={validations}
            />
          )}

          {currentTab === Tabs.Payments && (
            <PaymentsTab
              employeeId={selectedResultsRowData.employee.id}
              currentPolicyPeriodId={policyPeriodIds.current}
              payments={payments}
              employeeResultRowsData={employeeResultRowsData}
              currency={currency}
            />
          )}
        </Box>
      )}
    </Sidepanel>
  )
}

export default EmployeeSidePanel
